import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { TerritoryCode } from '~/lib/territories/territories';

import { getBenchmarks } from '../lib/benchmarks';

export interface BenchmarkQueryProps {
  uaid?: string;
  objective?: string;
  territoryCodes?: TerritoryCode[];
  platforms?: string[];
}

export function useBenchmarkQuery({
  uaid,
  objective,
  territoryCodes,
  platforms,
}: BenchmarkQueryProps) {
  return useQuery({
    enabled: !!uaid && !!objective,
    queryKey: [
      'campaign-benchmarks',
      uaid,
      objective,
      territoryCodes,
      platforms,
    ],
    queryFn: () => {
      return getBenchmarks({
        uaid,
        objective,
        territoryCodes,
        platforms,
      });
    },
    placeholderData: keepPreviousData,
    // @TODO WMG1-429 - Move this to the global QueryClient config options
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
}
